export enum LeaderboardVariant {
  Members = "members",
  Business = "business",
  Referral = "referral",
}
